import {AutoplayBasicState} from '@fantasmagames/slot/src/modules/autoplay/states/AutoplayBasicState';
import {RecodeGameAutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/recode/RecodeGameAutoplayHandlerModule';
import {AutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerModule';

export class RecodeAutoplayBasicState extends AutoplayBasicState {
	protected onAutoPlaySettingsAccepted(eventId: string, spinsLeft: number): void {
		if (!this.module.logic.autoplayData) {
			throw new Error('RecodeGameAutoplayHandlerModule::onAutoPlaySettingsAccepted this.logic.autoplayData is not initialized');
		}

		const recodeModule: RecodeGameAutoplayHandlerModule = this.module as RecodeGameAutoplayHandlerModule;

		recodeModule.startAutospins = recodeModule.autospinsLeft = spinsLeft;

		if (recodeModule.winLimitStartCheck() || recodeModule.lossLimitStartCheck()) {
			recodeModule.stopAutoplayAndEmitRoundsFinished();

			return;
		}

		if (recodeModule.canSpin) {
			recodeModule.winAmount = 0;

			//if (recodeModule.useWagerLimitAPI) {
				recodeModule.initVAPIAutoplay();
			//}

			recodeModule.tryToStartAutoplay();
		} else {
			recodeModule.isWaitingForSpinToFinish = true;
		}

		this.module.logic.lastAutoplayAmount = spinsLeft;
		this.module.gotoState(AutoplayHandlerModule.IN_PROGRESS);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/recode/states/RecodeAutoplayBasicState.ts